/*
 * https://redux-toolkit.js.org/rtk-query/overview#use-hooks-in-components
 * https://redux-toolkit.js.org/rtk-query/usage/queries
 **/

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { RootState } from '../app/store';
import type { Note } from '../features/note/noteSlice';
import type { User } from '../features/auth/user/userSlice';
import type {
	InitResponse,
	LoggedData,
	Session,
	SigninFormRequest,
	SignupFormRequest,
	SignupFormResponse,
	LoginFormResponse
} from '../features/auth/session/sessionSlice';
import { init, login, AuthRequest } from '../features/auth/session/sessionSlice';


export function NoteFromJson(json: any): Note {
	//
	// id
	let idVal: string | undefined;
	if (typeof json.id === 'string')
		idVal = json.id;
	else
		idVal = undefined;
	//
	// old_id
	let oldId: undefined;
	//
	// created
	let created = new Date('2022-11-18 04:00:00Z').toISOString();
	//
	// modified
	let modified = undefined;
	//
	// archived
	let archived = undefined;
	//
	// deleted
	let deleted = undefined;
	//
	// userId,
	let userId = '49b8e98f-0853-43f6-8928-b255a273274d';
	//
	// userName,
	let userName = 'thge';
	//
	// modifiedUserId,
	let modifiedUserId = '49b8e98f-0853-43f6-8928-b255a273274d';
	//
	// modifiedUserName,
	let modifiedUserName = 'thge';
	//
	// deletedUserId,
	//let deletedUserId = 'thge';
	//
	// deletedUserName,
	//let deletedUserName = 'thge';
	//
	// title
	let titleVal: string;
	if (json.title !== undefined && typeof json.title === 'string')
		titleVal = json.title;
	else
		throw new Error('json has no title string property');
	return {
		id: idVal,
		oldId: oldId,
		created: created,
		modified: modified,
		archived: archived,
		deleted: deleted,
		user: {id: userId, name: userName},
		modifiedUser: {id: modifiedUserId, name: modifiedUserName},
		deletedUser: undefined,
		title: titleVal,
		content: 'this is the content',
	}
}

let baseUrl: string;
switch(process.env.NODE_ENV) {
	case "development": {
		baseUrl = "/apidev";
		break;
	}
	case "test": {
		baseUrl = "/apidev";
		break;
	}
	case "production": {
		baseUrl = "/api";
		break;
	}
	default: {
		baseUrl = "/api";
		break;
	}
};

// Define a service using a base URL and expected endpoints
//
export const apiSlice = createApi({
	reducerPath: 'api',
	baseQuery: fetchBaseQuery({
		baseUrl: baseUrl,
		prepareHeaders: (headers, { getState, endpoint }) => {
			headers.set('rtk', 'value')
			if (endpoint !== 'uploadFile') {
			headers.set('Content-Type', 'application/json')
			}
			/*
			const token = (getState() as RootState)
			.user
			.session
			if (!token) {
				return headers;
			}
			// */
			//const token = session.token
			//if (token) {
			//	headers.set('authorization', `Bearer ${token}`)
			//}
			return headers;
		},
	}),
	endpoints: (builder) => ({
		init: builder.query<InitResponse | null, void> ({
			query: () =>  `/init`,
				async onQueryStarted(args, { dispatch, queryFulfilled } ) {
				// `onStart` side-effect
				console.log("request to init sent");
				try {
					const { data } = await queryFulfilled
					// `onSuccess` side-effect
					console.log('Data received:', data);
					dispatch(init(data))
				} catch (err) {
					//`onError` side-effect
					console.log('ho no, error in init');
					//dispatch(messageCreated('oh no, error'))
				}
			},
		}),
		/*
		login: builder.mutation<Session, SigninFormRequest>({
			query: (body) => {
			   return {
			   url:	   '/auth/signin',
			   method: 'POST',
			   body,
			   }
			},
			//*
			transformResponse: (rawResult: LoginFormResponse , meta) => {
				//return rawResult;
				console.log("loginFormResponse", rawResult);
				return SessionFromJson(rawResult);
			},
			// * /
			invalidatesTags:[],
			// https://redux-toolkit.js.org/rtk-query/api/createApi#onquerystarted
			async onQueryStarted(id, { dispatch, queryFulfilled }) {
				// onStart side-effect
				//dispatch()
				try {
					const {data } = await queryFulfilled
					localStorage.setItem('session', data.toString())
					// JSON.parse(localStorage.getItem("teeMeasuresAverages") || "")
					// on success side-effect
					dispatch(login(data))
					console.log("is this the good place to navigate");
				} catch (err) {
					//onError side-effect
					//dispatch('error fetching')
					console.log("arf error while trying to login");
				}
			}
		}),
		// */
		loginDiscord: builder.query<null, void>({
			query: () => `auth/discord`,
		}),
		authAuthorized: builder.query<null, AuthRequest>({
			query: (auth) =>
				`auth/authorized&state=${auth.state}&code=${auth.code}`
		}),
		fetchNoteById: builder.query<Note, string>(
			{			query: (id) => `/note/${id}`,		}			
		),
		fetchNotes: builder.query<Note, string>(
			{ query: (id) => `/note/${id}`	}
		),
	}),
})

export const {
   	useInitQuery,
   	//useLoginMutation,
   	useLoginDiscordQuery,
   	useLazyLoginDiscordQuery,
   	useAuthAuthorizedQuery,
   	useFetchNoteByIdQuery,
	useFetchNotesQuery,
} = apiSlice


